import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, AppText, ButtonRow, Button } from '@streem/ui-react';
export const ScreenshareRequestPrompt = () => {
    return (_jsxs(LargeWrapper, { "data-testid": "screenshare-request-prompt", children: [_jsx(RequestHeader, { as: "p", color: "dark", size: "medium", bold: true, children: "See the Customer's Screen" }), _jsx(AppText, { as: "p", color: "dark", size: "small", children: "This will prompt the customer to share their screen with you." })] }));
};
// NOTE: Not using these yet but copied from camera flip messages and they'll probably be needed on the next ticket
export const ScreensharePending = () => {
    return (_jsx(RequestPending, { color: "dark", size: "small", as: "p", children: "Requested Screenshare" }));
};
export const ExitScreenshare = () => {
    return (_jsxs(LargeWrapper, { "data-testid": "exit-screenshare-request-prompt", children: [_jsx(RequestHeader, { as: "p", color: "dark", size: "medium", bold: true, children: "Exit Screenshare" }), _jsx(AppText, { as: "p", color: "dark", size: "small", children: "This will return you to the video call." })] }));
};
export const ExitScreenshareRequestDenied = ({ onCancel, onRequest }) => {
    return (_jsxs(LargeWrapper, { "data-testid": "exit-screenshare-request-denied-prompt", children: [_jsx(DeniedHeader, { as: "p", color: "dark", size: "medium", bold: true, children: "Exit Screenshare Request Denied" }), _jsx(DeniedBody, { as: "p", color: "dark", size: "small", children: "Your request to see the customer's camera was denied." }), _jsxs(TooltipButtonRow, { children: [_jsx(Button, { variant: "tertiary", onClick: onCancel, children: "Cancel" }), _jsx(Button, { variant: "tertiary", onClick: onRequest, children: "Request Again" })] })] }));
};
export const ScreenshareRequestDenied = ({ onCancel, onRequest }) => {
    return (_jsxs(LargeWrapper, { "data-testid": "screenshare-request-denied-prompt", children: [_jsx(DeniedHeader, { as: "p", color: "dark", size: "medium", bold: true, children: "Screenshare Request Denied" }), _jsx(DeniedBody, { as: "p", color: "dark", size: "small", children: "Your request to see the customer's screen was denied." }), _jsxs(TooltipButtonRow, { children: [_jsx(Button, { variant: "tertiary", onClick: onCancel, children: "Cancel" }), _jsx(Button, { variant: "tertiary", onClick: onRequest, children: "Request Again" })] })] }));
};
const DeniedHeader = styled(AppText) `
    padding-bottom: 2px;
`;
const DeniedBody = styled(AppText) `
    padding-bottom: 6px;
`;
const RequestHeader = styled(AppText) `
    padding-bottom: 4px;
`;
const RequestPending = styled(AppText) `
    width: 150px;
    padding: 6px;
`;
const TooltipButtonRow = styled(ButtonRow) `
    display: flex;
    justify-content: flex-end;
`;
const LargeWrapper = styled.div `
    width: 200px;
    padding-left: 6px;
    padding-right: 6px;
    padding-bottom: 7px;
    padding-top: 4px;
`;
//# sourceMappingURL=screenshare_request_messages.js.map